var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"row mx-0",attrs:{"align-v":"end","align-h":"between"}},[_c('b-col',{staticClass:"d-flex justify-content-center mb-0"},[_c('h3',[_vm._v(_vm._s(_vm.org_name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }